import React, { useEffect, useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom';
import dataContext from './dataContext';

const pages = ['/', '/dashboard', '/users', '/partners', '/products', '/appointments', '/subscribers', '/propdesks', '/stock', '/selected-products', '/demat-users', '/payouts', '/achievements', '/ads']

const DataStates = ({ children }) => {
  const getAllowedPages = (pathname) => {
    if (pathname.startsWith('/partner/') && pathname.split('/').length === 3) {
      pages.push(pathname)
    }

    return pages;
  }

  const MONTHS_LIST = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];

  return (
    <dataContext.Provider value={{ getAllowedPages, MONTHS_LIST }}>
      {children}
    </dataContext.Provider>
  )
}

export default DataStates;